import api from "./api";

export const RESET_SEARCH = "tools/SEARCH/reset";

export const LOAD_DIMENSIONS_REQUEST = "tools/LOAD_DIMENSIONS/REQUEST";
export const LOAD_DIMENSIONS_SUCCESS = "tools/LOAD_DIMENSIONS/SUCCESS";
export const LOAD_DIMENSIONS_FAILURE = "tools/LOAD_DIMENSIONS/FAILURE";

export const LOAD_PRODUCT_GROUPS_REQUEST = "tools/LOAD_PRODUCT_GROUPS/REQUEST";
export const LOAD_PRODUCT_GROUPS_SUCCESS = "tools/LOAD_PRODUCT_GROUPS/SUCCESS";
export const LOAD_PRODUCT_GROUPS_FAILURE = "tools/LOAD_PRODUCT_GROUPS/FAILURE";

export const LOAD_PRODUCT_CATEGORIES_REQUEST = "tools/LOAD_PRODUCT_CATEGORIES/REQUEST";
export const LOAD_PRODUCT_CATEGORIES_SUCCESS = "tools/LOAD_PRODUCT_CATEGORIES/SUCCESS";
export const LOAD_PRODUCT_CATEGORIES_FAILURE = "tools/LOAD_PRODUCT_CATEGORIES/FAILURE";

export const LOAD_COUNTRIES_REQUEST = "tools/LOAD_COUNTRIES/REQUEST";
export const LOAD_COUNTRIES_SUCCESS = "tools/LOAD_COUNTRIES/SUCCESS";
export const LOAD_COUNTRIES_FAILURE = "tools/LOAD_COUNTRIES/FAILURE";

export const LOAD_WAREHOUSES_REQUEST = "tools/LOAD_WAREHOUSES/REQUEST";
export const LOAD_WAREHOUSES_SUCCESS = "tools/LOAD_WAREHOUSES/SUCCESS";
export const LOAD_WAREHOUSES_FAILURE = "tools/LOAD_WAREHOUSES/FAILURE";

export const LOAD_BRANDS_REQUEST = "tools/LOAD_BRANDS/REQUEST";
export const LOAD_BRANDS_SUCCESS = "tools/LOAD_BRANDS/SUCCESS";
export const LOAD_BRANDS_FAILURE = "tools/LOAD_BRANDS/FAILURE";

export const LOAD_SUPPLIERS_REQUEST = "tools/LOAD_SUPPLIERS/REQUEST";
export const LOAD_SUPPLIERS_SUCCESS = "tools/LOAD_SUPPLIERS/SUCCESS";
export const LOAD_SUPPLIERS_FAILURE = "tools/LOAD_SUPPLIERS/FAILURE";

export const FIND_PRODUCTS_REQUEST = "tools/FIND_PRODUCTS/REQUEST";
export const FIND_PRODUCTS_SUCCESS = "tools/FIND_PRODUCTS/SUCCESS";
export const FIND_PRODUCTS_FAILURE = "tools/FIND_PRODUCTS/FAILURE";

export const DUPLICATE_PRODUCT_REQUEST = "tools/DUPLICATE_PRODUCT/REQUEST";
export const DUPLICATE_PRODUCT_SUCCESS = "tools/DUPLICATE_PRODUCT/SUCCESS";
export const DUPLICATE_PRODUCT_FAILURE = "tools/DUPLICATE_PRODUCT/FAILURE";

export const UPDATE_PRODUCT_REQUEST = "tools/UPDATE_PRODUCT/REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "tools/UPDATE_PRODUCT/SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "tools/UPDATE_PRODUCT/FAILURE";


export function loadDimensions() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadDimensions()
                .then(
                    dimensions => {
                        dispatch(success(dimensions));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_DIMENSIONS_REQUEST };
    }

    function success(dimensions) {
        return {
            type: LOAD_DIMENSIONS_SUCCESS,
            dimensions
        };
    }

    function failure(errors) {
        return {
            type: LOAD_DIMENSIONS_FAILURE,
            errors
        };
    }
}


export function loadCountries() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadCountries()
                .then(
                    countries => {
                        dispatch(success(countries));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_COUNTRIES_REQUEST };
    }

    function success(countries) {
        return {
            type: LOAD_COUNTRIES_SUCCESS,
            countries
        };
    }

    function failure(errors) {
        return {
            type: LOAD_COUNTRIES_FAILURE,
            errors
        };
    }
}


export function loadWarehouses() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadWarehouses()
                .then(
                    warehouses => {
                        dispatch(success(warehouses));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_WAREHOUSES_REQUEST };
    }

    function success(warehouses) {
        return {
            type: LOAD_WAREHOUSES_SUCCESS,
            warehouses
        };
    }

    function failure(errors) {
        return {
            type: LOAD_WAREHOUSES_FAILURE,
            errors
        };
    }
}

export function loadBrands() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadBrands()
                .then(
                    brands => {
                        dispatch(success(brands));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_BRANDS_REQUEST };
    }

    function success(brands) {
        return {
            type: LOAD_BRANDS_SUCCESS,
            brands
        };
    }

    function failure(errors) {
        return {
            type: LOAD_BRANDS_FAILURE,
            errors
        };
    }
}


export function loadProductGroups() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadProductGroups()
                .then(
                    productGroups => {
                        dispatch(success(productGroups));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_PRODUCT_GROUPS_REQUEST };
    }

    function success(productGroups) {
        return {
            type: LOAD_PRODUCT_GROUPS_SUCCESS,
            productGroups
        };
    }

    function failure(errors) {
        return {
            type: LOAD_PRODUCT_GROUPS_FAILURE,
            errors
        };
    }
}

export function loadProductCategories() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadProductCategories()
                .then(
                    productCategories => {
                        dispatch(success(productCategories));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_PRODUCT_CATEGORIES_REQUEST };
    }

    function success(productCategories) {
        return {
            type: LOAD_PRODUCT_CATEGORIES_SUCCESS,
            productCategories
        };
    }

    function failure(errors) {
        return {
            type: LOAD_PRODUCT_CATEGORIES_FAILURE,
            errors
        };
    }
}

export function loadSuppliers() {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.loadSuppliers()
                .then(
                    suppliers => {
                        dispatch(success(suppliers));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: LOAD_SUPPLIERS_REQUEST };
    }

    function success(suppliers) {
        return {
            type: LOAD_SUPPLIERS_SUCCESS,
            suppliers
        };
    }

    function failure(errors) {
        return {
            type: LOAD_SUPPLIERS_FAILURE,
            errors
        };
    }
}

export function findProducts(code) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.findProducts(code)
                .then(
                    products => {
                        dispatch(success(products));
                        resolve();
                    },
                    errors => {
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: FIND_PRODUCTS_REQUEST };
    }

    function success(products) {
        return {
            type: FIND_PRODUCTS_SUCCESS,
            products
        };
    }

    function failure(errors) {
        return {
            type: FIND_PRODUCTS_FAILURE,
            errors
        };
    }
}

export function duplicateProduct(id, parameters) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.duplicateProduct(id, parameters)
                .then(
                    () => {
                        dispatch(success());
                        resolve();
                    },
                    errors => {
                        console.log("in errors");
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: DUPLICATE_PRODUCT_REQUEST };
    }

    function success() {
        return { type: DUPLICATE_PRODUCT_SUCCESS };
    }

    function failure(errors) {
        return {
            type: DUPLICATE_PRODUCT_FAILURE,
            errors
        };
    }
}

export function updateProduct(id, parameters) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            dispatch(request());
            api.updateProduct(id, parameters)
                .then(
                    () => {
                        dispatch(success());
                        resolve();
                    },
                    errors => {
                        console.log("in errors");
                        dispatch(failure(errors));
                        resolve();
                    }
                );

        });
    };

    function request() {
        return { type: UPDATE_PRODUCT_REQUEST };
    }

    function success() {
        return { type: UPDATE_PRODUCT_SUCCESS };
    }

    function failure(errors) {
        return {
            type: UPDATE_PRODUCT_FAILURE,
            errors
        };
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Tools/reducer/actions.js